export class Location {
    public locationId: number;
    public code: string;
    public description: string;
    public rentFrom: boolean;
    public returnTo: boolean;
    public hideInWebList: boolean;
    public isAirport: boolean;
    public longitude: number;
    public latitude: number;
}